import React from "react";

interface BottomCTAProps {
  isVisible: boolean;
  onOpenModal: () => void;
}

const BottomCTA: React.FC<BottomCTAProps> = ({ isVisible, onOpenModal }) => {
  return (
    <section id="bottom-cta" className="py-24 bg-gradient-to-b from-white to-slate-50">
      <div className="container mx-auto px-4">
        <div className={`max-w-4xl mx-auto text-center relative transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {/* Gradient Background Effect */}
          <div className="absolute inset-0 bg-gradient-to-r from-indigo-600 to-blue-600 rounded-3xl blur-2xl opacity-20"></div>
          
          {/* Main CTA Card */}
          <div className="relative bg-gradient-to-br from-indigo-600 via-blue-600 to-indigo-700 rounded-3xl p-12 md:p-16 shadow-2xl overflow-hidden">
            {/* Decorative Orbs */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-blue-400/20 rounded-full blur-2xl"></div>
            
            {/* Content */}
            <div className="relative z-10">
              <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-6">
                Start Monitoring Your AI Costs Today
              </h2>
              <p className="text-xl text-blue-50 mb-4 max-w-2xl mx-auto leading-relaxed">
                Join hundreds of teams preventing AI API overspending with real-time alerts. Get started in 60 seconds—no credit card required.
              </p>
              
              {/* Trust Badges */}
              <div className="flex flex-wrap items-center justify-center gap-6 mb-10 text-blue-100 text-sm">
                <div className="flex items-center gap-2">
                  <svg className="w-5 h-5 text-emerald-300" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  14-day free trial
                </div>
                <div className="flex items-center gap-2">
                  <svg className="w-5 h-5 text-emerald-300" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  No credit card required
                </div>
                <div className="flex items-center gap-2">
                  <svg className="w-5 h-5 text-emerald-300" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  Cancel anytime
                </div>
              </div>

              {/* Primary CTA Button */}
              <button
                onClick={onOpenModal}
                className="inline-block bg-white text-indigo-600 hover:bg-gray-50 font-bold px-10 py-5 rounded-full text-lg transition-all transform hover:scale-105 shadow-2xl hover:shadow-3xl"
              >
                Get Started Free
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BottomCTA;
